jQuery(document).ready(function($) {
    const base = "gc-add-to-cart";

	$(`.${base}`).submit(function(e) {
		e.preventDefault();
		$(this).attr('data-loading', 'true')

		const formData = $(this).serialize();
		const url = $(this).attr('action');
		$.ajax({
			url : url,
			type: 'POST',
			data : formData
		}).done(responseRaw => {
			$(this).attr('data-loading', 'false')
			const response = JSON.parse(responseRaw);
			
			if(response.success) {
				showToast(response.message);
			} else {
				showToast('Error');
			}
		});
	});
});